<div class="app-container">
  <!-- Sidebar Navigation (always visible, collapses to icons) -->
  <aside
    class="app-sidebar"
    [class.sidebar-expanded]="sidebarExpanded()"
    [class.sidebar-collapsed]="!sidebarExpanded()"
    [class.sidebar-pinned]="sidebarPinned()"
    (mouseenter)="onSidebarMouseEnter()"
    (mouseleave)="onSidebarMouseLeave()"
  >
    <!-- Sidebar Header. Hidden below 992px: the topbar owns the mark on mobile, and the
         drawer slides in over the page next to it, so showing this one duplicates it.
         The pin button is desktop-only already, so nothing else is lost. Display lives
         in the utility classes, not .sidebar-header, because the encapsulated
         `.sidebar-header[_ngcontent-*]` selector would outrank Tailwind's `hidden`. -->
    <div
      class="sidebar-header hidden desktop:flex items-center justify-between"
    >
      <a [href]="homeLink" class="sidebar-logo">
        @if (sidebarExpanded()) {
          <img src="/assets/img/nymbl_dot.svg" alt="Nymbl" class="logo-full" />
        } @else {
          <img src="/assets/img/nymbl_logo.svg" alt="Nymbl" class="logo-icon" />
        }
      </a>
      @if (sidebarExpanded()) {
        <p-button
          class="hidden lg:flex"
          [icon]="sidebarPinned() ? 'pi pi-lock' : 'pi pi-lock-open'"
          [text]="true"
          [rounded]="true"
          (onClick)="toggleSidebarPin()"
          [attr.aria-label]="sidebarPinned() ? 'Unpin menu' : 'Pin menu'"
          [attr.aria-pressed]="sidebarPinned()"
        >
        </p-button>
      }
    </div>

    <!-- Sidebar Content -->
    <ng-content select="[nymbl3Menu]">
      <app-menu></app-menu>
    </ng-content>
  </aside>

  <!-- Main Content Area -->
  <div class="main-content-area" [class.sidebar-expanded]="sidebarExpanded()">
    <app-topbar>
      <ng-container ngProjectAs="[topbarControls]">
        <ng-content select="[topbarControls]" />
      </ng-container>
    </app-topbar>

    <div class="page-content">
      <!-- Content projection for page content (router-outlet, upgrade component, etc.) -->
      <ng-content select="[pageContent]" />
    </div>
  </div>
</div>

<!--
  Mounted here rather than in either root component, because this shell is the
  one thing every authenticated screen has in common: nymbl2's AppShellComponent,
  nymbl3's NymblClassicShellComponent, and the LMN therapist guest route all
  render it. Mounting it in each root component instead would put it above the
  router, where the LMN route's SESSION_SERVICE override is not visible.
-->
<nymbl-session-timeout></nymbl-session-timeout>
